import ReceiptIcon from "@mui/icons-material/Receipt";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import HouseIcon from "@mui/icons-material/House";

const dashboardActionsCards = [
    {
        title: "Generate Invoice",
        description: "Generate invoice at ease",
        icon: ReceiptIcon,
        bgColor: "#4caf50",
        navigateTo: "/invoice",
    },
    {
        title: "Add New Building",
        description: "Add new building quickly & easily.",
        icon: ApartmentIcon,
        bgColor: "#2196f3",
        navigateTo: "/building",
    },
    {
        title: "Add New Tenant",
        description: "Add new tenant quickly & easily.",
        icon: PersonAddAltIcon,
        bgColor: "#ff9800",
        navigateTo: "/tenant",
    },
    {
        title: "Add New Property",
        description: "Add new property quickly & easily.",
        icon: HouseIcon,
        bgColor: "#f44336",
        navigateTo: "/rental-property",
    },
];

export default dashboardActionsCards;
